import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAiStatus } from "../../../../ai/useAiStatus";
import { BuildWithAiModal } from "../aiBuilder/BuildWithAiModal";
import { TaskTemplatesListHeader } from "../components/TaskTemplatesListHeader";
import {
  TaskTemplatesConfirmModals,
  TaskTemplatesDuplicateModal,
  TaskTemplatesImportModal,
} from "../components/TaskTemplatesModals";
import { TaskTemplatesTable } from "../components/TaskTemplatesTable";
import { useTaskTemplatesListController } from "../hooks/useTaskTemplatesListController";
import { TaskTemplateListStatus } from "../model/taskTemplatesList.types";

type Props = {
  initialStatus?: TaskTemplateListStatus;
};

export const TaskTemplatesPage: React.FC<Props> = ({
  initialStatus = "all",
}) => {
  const {
    headerProps,
    tableProps,
    confirmModalProps,
    importModalProps,
    duplicateModalProps,
  } = useTaskTemplatesListController(initialStatus);
  const navigate = useNavigate();
  const { isOn: aiOn, status: aiStatus } = useAiStatus();
  const [isBuildOpen, setIsBuildOpen] = useState(false);

  return (
    <>
      <div className={"mb-[120px] py-6"}>
        <TaskTemplatesListHeader
          {...headerProps}
          onBuildWithAi={
            aiOn && aiStatus?.canManage ? () => setIsBuildOpen(true) : undefined
          }
        />
        <TaskTemplatesTable {...tableProps} />
      </div>
      <TaskTemplatesConfirmModals {...confirmModalProps} />
      <TaskTemplatesImportModal {...importModalProps} />
      <TaskTemplatesDuplicateModal {...duplicateModalProps} />
      {isBuildOpen && (
        <BuildWithAiModal
          onClose={() => setIsBuildOpen(false)}
          onSaved={(id) => {
            setIsBuildOpen(false);
            navigate(`/settings/templates/task-templates/view/${id}`);
          }}
        />
      )}
    </>
  );
};
